<template>
    <div class="container">
        <!-- <h1>Nhập liệu</h1>

        <hr/> -->

        <div class="row mt-2" v-if="!isLoading">
            <template v-for="input in forms">

            <div :class="'col-md-'+(input.colspan?input.colspan:6)" v-if="input.type=='line'" v-bind:key="input.col">
                <hr/>
            </div>

            <div :class="'col-md-'+(input.colspan?input.colspan:6)" v-if="input.type=='label'" v-bind:key="input.col">
                <h2>{{input.defaultValue}}</h2>
            </div>

            <b-form-group :class="'col-md-'+(input.colspan?input.colspan:6)" 
                v-bind:key="'f'+input.col" 
                v-if="input.visible && isFormControl(input)" 
                :set="field = columns[input.col]">
                    <!-- <label class="input-header" >Debug: {{field ? field.name : ''}} </label> -->

                    <label class="input-header" >
                        {{ input.label ? input.label : (field!=null?field.alias:input.col+' not found') }} 
                        <span v-if="input.required" class="text-red">*</span> 
                    </label>
                    <b-button class="ml-1" variant="warning" size="sm" v-if="input.hint" v-b-popover.hover.top="input.hint">?</b-button>

                    <p variant="danger" class="text-red" show v-if="input.error">{{input.error}}</p>

                    <br/>
                    <p class="badge" v-if="debugMode">({{input.value}})</p>

                    <div v-if="columns[input.col] != null">
                        <div v-if="input.type=='image'">
                            <img-form-field :image_url="input.value" @image_changed="input.value=$event"></img-form-field>
                        </div>

                        <div v-if="input.type=='date'">
                            <b-form-input 
                                type="date" 
                                v-model="input.value" 
                                :placeholder="field.alias"
                                :disabled="input.disabled"
                                />
                        </div>

                        <div v-if="input.type=='checkbox'">
                            <b-form-checkbox
                                v-model="input.value"
                                value="true"
                                unchecked-value="false"
                                :disabled="input.disabled"
                                >
                                {{field.alias}}
                                </b-form-checkbox>
                        </div>

                        <div v-if="input.type=='text'">
                            <b-form-input type="text" 
                                v-model="input.value" 
                                :placeholder="field.alias"
                                :disabled="input.disabled"
                                />

                            <div v-if="input.checkExist">
                                <b-button v-if="!isCheckingExist" variant="primary" size="sm" @click="checkExist(input.col, input.value)">Kiểm tra</b-button>
                                <span v-else>Đang kiểm tra...</span>
                                <span>{{ " " + checkingMessage + " "}}</span>
                                <span v-if="isExist && existId">
                                    <b-button v-if="canViewExist" pill variant="info" size="sm" @click="viewExistRecord">Xem</b-button>
                                </span>
                            </div>

                            
                        </div>

                        <div v-if="input.type=='link'">
                            <b-form-input type="text" 
                                v-model="input.value" 
                                :placeholder="field.alias"
                                :disabled="input.disabled"
                                />
                        </div>

                        <div v-if="input.type=='textarea'">
                            <b-form-textarea
                                :id="input.col"
                                v-model="input.value"
                                :placeholder="field.alias"
                                :disabled="input.disabled"
                                rows="3"
                                ></b-form-textarea>
                        </div>

                        <div v-if="input.type=='select'">
                            <b-form-select 
                                v-model="input.value" 
                                :options="field.options"  
                                :placeholder="field.alias"
                                :disabled="input.disabled"
                                @change="input.change?input.change($event,forms):function(){}"
                                ></b-form-select>
                        </div>

                        <div v-if="input.type=='multi-select'">
                            <multiselect 
                                v-model="input.value" 

                                :searchable="false"
                                :close-on-select="false"
                                :multiple="true"
                                :options="field.options"
                                :placeholder="field.alias"
                                :disabled="input.disabled">
                                </multiselect>
                        </div>

                        <div v-if="input.type=='typeahead'">

                            <!-- <p>{{input.options}}</p> -->

                            <vue-bootstrap-typeahead 
                                v-model="input.value"
                                :minMatchingChars="1"
                                :data="input.options"
                                :serializer="input.optionLabel"
                                @hit="typeaheadHitEvent($event,input)"
                                :placeholder="field.alias"
                                :disabled="input.disabled"
                                ref="typeahead"
                                /> 
                        </div>

                        <div v-if="input.type=='number'">
                            <b-form-input 
                                type="number" 
                                v-model="input.value"  
                                step="0.001" 
                                min="0.000" 
                                max="1000000.000"
                                :placeholder="field.alias"
                                :disabled="input.disabled"/>
                        </div>

                        <div v-if="input.type=='image_list'">
                            <img-list-form-field 
                                :list_urls="input.value"
                                :images_folder="images_table"
                                @list_changed="input.value=$event"></img-list-form-field>
                        </div>
                    </div>
            </b-form-group>
            </template>
        </div>

        <div class="row" v-if="isLoading">
            Loading...
        </div>

        <div class="row" v-if="isLoadingImages" style="color: red; font-size: 30px">
            Đang upload Images...
        </div>

        <div class="row" v-if="!isLoading">
            <div class="col-md-4 offset-md-8">
                <b-button variant="primary" size="large" @click="submit()">Lưu lại</b-button>
                <b-button variant="danger" size="large" @click="deleteCurrent()" v-if="!isNewRecord">Xoá</b-button>
                <b-button variant="primary" size="large" @click="createNewItem()" v-if="!isNewRecord">Tạo mới</b-button>
            </div>
        </div>
    </div>

</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
import Multiselect from 'vue-multiselect'

import Constants from '@/constants'
import TableMeta from '@/models/OnlineScanTableMeta'
import StreetData from '@/models/StreetData'
import moment from 'moment'
import axios from 'axios'
import Firebase from "../../services/firebase.js"
import ImageFormField from '@/views/base/ImageFormField'
import ImagesFormField from '@/views/base/ImagesFormField'

export default {
  name: 'GenericFormView',
  components: {
    'vue-bootstrap-typeahead': VueBootstrapTypeahead,
    Multiselect,
    'img-form-field': ImageFormField,
    'img-list-form-field': ImagesFormField
    },
  props: ['rootPath', 'forms', 'columns', 'table_name', 'skipAutoReset'],
  data () {
    return {
        debugMode: false,
        fields_map: {},
        id: null,
        isNewRecord: false,
        isLoading: false,
        images: null,
        images_table: this.table_name.slice(0, -1) + "_images",
        isSelectingImages : false,
        date_images: null,
        isLoadingImages: false,

        isCheckingExist: false,
        isExist: false,
        existId: null,
        canViewExist: false,
        checkExistFields: [],
        checkingMessage: '',    
    }
  },
  computed: {
    entity() {
        return this.table_name.split('.')[1].slice(0, -1);
    },
    role() {
      console.log('GenericFormView::role::trying to get user role: ', this.$store.state.userRole)
      if (this.$store.state.userRole) {
        return this.$store.state.userRole;
      }

      return 'ctv'; // default role
    },

    email() {
      console.log('GenericFormView::email::trying to get user email: ', this.$store.state.userEmail)
      if (this.$store.state.userEmail) {
        return this.$store.state.userEmail;
      }

      return ''; // empty
    },

    salename() {
        console.log('GenericFormView::salename::trying to get user salename: ', this.$store.state.salename)
      if (this.$store.state.salename) {
        return this.$store.state.salename;
      }

      return ''; // empty
    }
  },
  watch: {

  },
  methods: {
      isFormControl(input) {
          return input.type!='line' && input.type != 'label'
      },
    getValueFromField (field) {
        if(field.value) {
            if(field.value instanceof Array && field.type === 'image_list') {
                var s = JSON.stringify(field.value);
                return "'" + s + "'";
            }
            else if(field.value instanceof Array) {
                return "'" + field.value.join(',') + "'";
            } else if(field.value instanceof String) {
                return "'" + field.value + "'";
            } else {
              if(field.type === 'text' 
                || field.type === 'link' 
                || field.type === 'select' 
                || field.type === 'multi-select'
                || field.type === 'textarea' 
                || field.type === 'typeahead' 
                || field.type === 'image'
                ) {
                  return "'" + field.value + "'";
              }
              else if(field.type === 'date') {
                //   return "'" + moment(field.value).format("yyyy-MM-DD HH:mm:ss") + "'";

                  var time = moment(field.value+' '+ moment().format('HH:mm:ss'))

                  return "'" + moment(time).format("yyyy-MM-DD HH:mm:ss") + "'";
              }
              else {
                  return field.value;
              }
            }
        }

        return null;
    },

    typeaheadHitEvent (event, input) {
        if(input.hitFunction) {
            input.hitFunction(event, this.forms, input);
        }

        if(event.col == 'street') {
            input.value = event.ward + ' > ' + event.street + ' > ' + event.street_2
        }
        // else {
        //     input.value = event.value;
        // }
    },

    generateInsertImagesQuery(images) {
        console.log(images);

        const columns = ["url", `${this.entity}_id`, "file_name"];
        var query = `INSERT INTO ${this.images_table} (${columns.join(',')}) VALUES`;
        query += images.map(image => `('${encodeURIComponent(image.url)}', ${this.id}, '${image.file_name}')`).join(',');

        console.log(query);
        return query;
    },

    generateInsertQuery(columns, values) {
        var query = 'INSERT INTO ' + this.table_name + ' (';
        query += columns.join(',');
        query += ') VALUES (';
        query += values.join(',');
        query += ');';

        return query;
    },

    generateSelectQuery() {
        var query = 'SELECT ';

        var columns = [];
        for(var i in this.forms) {
            if(this.forms[i].type === 'line' || this.forms[i].type === 'images' || this.forms[i].type === 'label') {
                // skip this as this is a non-column field
                continue;
            }

            columns.push(this.forms[i].col);
        }
        query += columns.join(',') + ' ';
        query += 'FROM ' + this.table_name + ' ';
        query += 'WHERE id=' + this.id + ';';

        return query;
    },

    generateCheckExistQuery(col, value) {
        var query = `SELECT * FROM ${this.table_name} WHERE ${col}=${value}`;

        return query;
    },

    generateSelectImageQuery() {
        return `SELECT ${this.entity}_id, JSON_OBJECTAGG(updated_at, images) as images FROM ( SELECT ${this.entity}_id, updated_at, GROUP_CONCAT(CONCAT("{\\"id\\":",p_img.id,",\\"file_name\\":\\"",file_name,"\\",\\"url\\":\\"",url,"\\"}") SEPARATOR ', ') AS images FROM ${this.table_name} AS p LEFT JOIN ${this.images_table} AS p_img ON p.id = p_img.${this.entity}_id WHERE p.id=${this.id} and p_img.product_id =${this.id} GROUP BY updated_at ) AS images_table GROUP BY ${this.entity}_id;`
    },

    generateUpdateQuery() {
        var columns = [];
        for(var i in this.forms) {
            var f = this.forms[i];
            if((f.value != f.oldValue)&& (f.type != 'label') && (f.type != 'label') && (f.type != 'line') || (f.col == 'image_list')) {
                columns.push(f.col + '=' + this.getValueFromField(f));
            }
        }

        console.log("columns to update: ", columns);

        if (columns.length == 0) {
            return null;
        }

        var query = 'UPDATE ' + this.table_name + ' SET ';
        query += columns.join(',');
        query += ' WHERE id=' + this.id + ';';

        return query;
    },

    generateDeleteQuery() {
        var query = 'DELETE FROM ' +this.table_name+' ';
        query += 'WHERE id=' + this.id;
        return query;
    },

    generateDeleteImagesQuery(ids) {
        var query = 'DELETE FROM ' + this.images_table +' ';
        query += 'WHERE id IN (' + ids.join(',') + ')';
        return query;
    },

    async insertNewRecord() {
        this.isLoading = true;
        console.log('form: ', this.forms);

        var columns = [];
        var values = [];
        var created_by_existed = false;
        for(var i in this.forms) {
            var f = this.forms[i];
            if(f.value) {
                columns.push(f.col);
                values.push(this.getValueFromField(f))             
            }

            if(f.col == 'created_by') {
                created_by_existed = true;
            }
        }

        if(this.email && !created_by_existed) {
            columns.push('created_by');
            values.push("'" + this.email + "'");
        }

        var query = this.generateInsertQuery(columns, values);
        console.log(query);

        var url = Constants.HOST_URL + 'runQuery/insert';

        try {
            var response = await axios.post(url,{
                query: query
            });
            console.log(response.data);

            this.id = response.data.insertId;
            return true;
            
            // this.$router.replace({ path: `${this.rootPath}/${this.id}` });
        }
        catch (e) {
            alert(e);
            return false;
        }
        
        this.isLoading = false;
    },

    async updateExistingRecord() {
        this.isLoading = true;
        var query = this.generateUpdateQuery();
        console.log(query);

        if (query) {
            var url = Constants.HOST_URL + 'runQuery/insert';

            try {
                var response = await axios.post(url,{
                    query: query
                });
                console.log(response.data);
            }
            catch (e) {
                alert(e);
            }
        }

        this.isLoading = false;
    },

    resetValidationState() {
        for(var i =0; i<this.forms.length; i++) {
            this.forms[i].error = null;
        }
    },

    async validateInput() {
        var hasError = false;
        this.checkExistFields = [];

        // Every required field should be filled-in
        // Or they need to comply to the validation rules
        for(var i =0; i<this.forms.length; i++) {
            var f = this.forms[i];

            if (f.checkExist) {
                this.checkExistFields.push({col: f.col, value: f.value});
            }

            if(!f.value && f.required) {
                f.error = "'" + this.columns[f.col].alias + "' không được bỏ trống";
                hasError = true;
            }

            if(f.value && f.validationFunc) {
                var result = f.validationFunc(f);
                
                if(!result) {
                    hasError = true;
                }
            }
        }

        if(hasError) {
            return false;
        }

        return true;
    },

    async hasExistingFields () {
        for (let field in this.checkExistFields) {
            await this.checkExist(this.checkExistFields[field].col, this.checkExistFields[field].value);
            if (this.isExist) {
                return true;
            }
        }

        return false;
    },

    async submit() {
        this.isLoading = true;

        this.resetValidationState();

        var ret = await this.validateInput();
        if(!ret) {
            console.log('validation falied');
            alert('Có lỗi trong quá trình nhập liệu, vui lòng kiểm tra lại.');
            this.isLoading = false;
            return;
        }

        var hasExistData = await this.hasExistingFields();
        if (hasExistData) {
            console.log('validation: exist record!');
            alert(`Dữ liệu đã tồn tại, vui lòng liên hệ admin.`);
            this.isLoading = false;
            return;
        }

        var isNewRecord = !this.id || this.id === 'new';

        if(isNewRecord) {
            await this.insertNewRecord()
        }
        else {
            await this.updateExistingRecord();
            this.refresh();
        }

        if(this.id) {
            this.$emit("onSubmitted", this.id, isNewRecord)
        }
        else {
            // error happening during the insert
        }
        
    },

    async deleteCurrent () {
        let storage = Firebase.getStorage().ref().child(this.images_table);

        var r = confirm("Thao tác xoá sẽ không thể phục hồi lại. Bạn có muốn xoá dữ liệu?");
        if (r == true) {
            
        } else {
            return;
        }

        this.isLoading = true;
        var query = this.generateDeleteQuery();

        var url = Constants.HOST_URL + 'runDeleteQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);

            let imageNames = [];
            this.date_images.forEach(item => {
                item.images.forEach(image => {
                    imageNames.push(image.file_name);
                });
            });

            for (let i = 0; i < imageNames.length; i++) {
                storage.child(imageNames[i]).delete();
            }
        }
        catch (e) {
            alert(e);
        }

        this.isLoading = false;

        alert('Dữ liệu đã được xoá');

        this.$router.replace({ path: `${this.rootPath}` }) 
    },

    createNewItem () {
        var routeData = this.$router.resolve({ path: `${this.rootPath}/new` });
        window.open(routeData.href, 'new_product');
    },

    async checkExist(col, value) {
        this.checkingMessage = '';

        this.isExist = false;
        this.existId = null;        
        this.isCheckingExist = true;
        this.canViewExist = false;

        if(!value)
            return false;

        var query = this.generateCheckExistQuery(col, value);
        console.log('query: ', query);

        if (query) {
            var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;
            try {
                var response = await axios.get(url);
                if(!response.data) {
                    alert('Error while run select query for: ' + col + " " + value);
                    this.isCheckingExist = false;
                    return;
                } else if (response.data.length < 1) {
                    this.checkingMessage = 'Chưa tồn tại!';
                    this.isCheckingExist = false;
                    return;
                }

                let existedIds = [];
                const existedItems = response.data;

                existedItems.forEach(item => {
                    existedIds.push(item.id + '');
                });

                const currentId = this.id;

                if (!currentId || currentId === 'new') { // insert new record
                    this.isExist = true;
                    this.existId = existedItems[0].id;
                    this.canViewExist = existedItems[0].sale === this.salename;
                    this.checkingMessage = 'Đã tồn tại!';
                } else if (currentId) {  // update current record
                    console.log(currentId);
                    const existedIdx = existedIds.indexOf(currentId)

                    if (existedIdx < 0) { // current record has field duplicate with others
                        this.isExist = true;
                        this.existId = existedItems[0].id;
                        this.canViewExist = existedItems[0].sale === this.salename;
                        this.checkingMessage = 'Đã tồn tại!';
                    } else { // current record has field duplicate itself
                        // meaning not duplicate
                        this.isExist = false;
                        this.existId = null;
                        this.canViewExist = false;
                        this.checkingMessage = 'Chưa tồn tại!';
                        this.isCheckingExist = false;
                        return;
                    }
                }

                console.log(response.data);
            }
            catch (e) {
                alert(e);
            }
        }

        this.isCheckingExist = false;
    },

    viewExistRecord () {
        this.$emit("onViewExistRecord", this.existId)
    },

    parseRecordIntoFormValue(record) {
        for(var i = 0; i<this.forms.length; i++) {
            if(this.forms[i].type === 'line' || this.forms[i].type === 'label' || this.forms[i].type === 'images') {
                // skip this as this is a non-column field
                continue;
            }

            

            if(record[this.forms[i].col]) {
                var v = record[this.forms[i].col];

                var form = this.forms[i]

                if(form.type === 'date') {
                    form.value= moment(v).format('yyyy-MM-DD');
                } else if(form.type === 'multi-select') {
                    form.value= v.split(',');
                } else if(form.type === 'checkbox') {
                    form.value= (v == 1?true:false);
                } else if(form.type === 'typeahead') {
                    // this type is a little tricky
                    form.value = v;
                } else if(form.type === 'image_list') {
                    const images = JSON.parse(v);
                    form.value = images;
                }
                else {
                    form.value=v;
                }
                

                form.oldValue = form.value;
            }
        }

        for(var i = 0; i<this.forms.length; i++) {
            if(this.forms[i].onInit) {
                console.log('onInit');
                this.forms[i].onInit(this.forms[i], this.forms);
            }
        }
        console.log('record after parsed: ', this.forms);
    },

    async refresh () {
        this.resetFormValue();

        this.isLoading = true;
        var query = this.generateSelectQuery();
        console.log('query: ', query);

        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;

        try {
            var response = await axios.get(url);
            if(!response.data || response.data.length != 1) {
                alert('Error while downloading record ' + this.id);
                return;
            }

            if (this.table_name.includes('products')) {
                var image_query = this.generateSelectImageQuery();
                var image_url = Constants.HOST_URL + 'runSelectQuery?query=' + encodeURIComponent(image_query);
                var responseImages = await axios.get(image_url);

                console.log({...response.data[0], ...responseImages.data[0]});
                this.parseRecordIntoFormValue({...response.data[0], ...responseImages.data[0]});
            } else {
                console.log(response.data[0]);
                this.parseRecordIntoFormValue(response.data[0]);
            }
        }
        catch (e) {
            alert(e);
        }

        this.isLoading = false;
    },

    resetFormValue () { 
        for(var i=0; i<this.forms.length;i++) {
            if(typeof this.forms[i].defaultValue === 'function' ) {
                this.forms[i].value = this.forms[i].defaultValue();
            }
            else {
                this.forms[i].value = this.forms[i].defaultValue;
                // if (this.forms[i].type=='text' && this.forms[i].col=='code') {
                //     this.forms[i].value += Math.floor(Math.random() * (99999 - 10000) + 10000);
                // }
            }
        }
    },

    toggleSelectImages() {
        this.isSelectingImages = !this.isSelectingImages;

        if (!this.isSelectingImages) {
            this.date_images.forEach(item => {
                item.images.forEach(image => {image.selected = false})
            });
        }
    },

    toggleImage(image) {
        if (this.isSelectingImages) {
            image.selected = !image.selected;
        }
    },

    async deleteSelectedImages() {
        let storage = Firebase.getStorage().ref().child(this.images_table);
        let selectedImageIds = [];
        let selectedImageNames = [];

        this.date_images.forEach(item => {
            item.images.forEach(image => {
                if (image.selected) {
                    selectedImageIds.push(image.id)
                    selectedImageNames.push(image.file_name);
                }
            });
        });

        var txt;
        var r = confirm("Thao tác xoá sẽ không thể phục hồi lại. Bạn có muốn xoá dữ liệu?");
        if (r == true) {
            
        } else {
            return;
        }

        this.isLoading = true;
        var query = this.generateDeleteImagesQuery(selectedImageIds);

        var url = Constants.HOST_URL + 'runDeleteQuery?query=' + query;

        try {
            var response = await axios.get(url);

            if(!response.data) {
                alert('Error while deleting images');
                return;
            }
            
            for (let i = 0; i < selectedImageNames.length; i++) {
                storage.child(selectedImageNames[i]).delete();
            }
        }
        catch (e) {
            alert(e);
        }

        this.date_images.forEach(item => {
            item.images = item.images.filter(image => !image.selected);
        });

        this.isLoading = false;

        alert('Hình đã được xoá');
    },

    copyToClipboard (value) {
        var tempInput = document.createElement("input");
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
    },
  },
  mounted () {
      // Only reset form values if not being used as a child component with pre-populated data
      if (!this.skipAutoReset) {
        this.resetFormValue();
      }

      // Only manage route-based lifecycle if not being used as a child component
      if (!this.skipAutoReset && this.$route && this.$route.params) {
        this.id = this.$route.params.id;
        console.log('id: ' + this.id);
        if(!this.id || this.id === 'new') {
          this.isNewRecord = true;
          // this is a new object
          this.$emit("onShowTool", false)
        }
        else {
          this.isNewRecord = false;
          this.$emit("onShowTool", true)

          this.refresh()
        }
      } else {
        // When used as child component, always treat as new record
        this.isNewRecord = true;
        this.id = 'new';
        this.$emit("onShowTool", false)
      }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped> 

.text-red {
    color: red;
}

.input-header {
    font-weight: bold;
}

.image {
    display: inline-block;
    margin: 5px;
    cursor: pointer;
}

.center-cropped {
  object-position: center; /* Center the image within the element */
  height: 150px;
  width: 150px;
}

.thumbnail {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  width: auto;
  -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
          transform: translate(-50%,-50%);
  transition: transform .2s;
}
.thumbnail img.portrait {
  width: 100%;
  height: auto;
}

.selecting {
  border: 2px solid gray;
  padding: 10px;
}

.active {
  border: 3px solid blue;
}
</style>

<style>
.vbst-item {
    background: white;
}
</style>
